import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaYoutube, FaInstagram } from "react-icons/fa";
import { IoLogoTwitter } from "react-icons/io";

const portalLinks = [
  { label: "Home", to: "/academics/postgraduate" },
  { label: "About", to: "/academics/postgraduate/about" },
  { label: "Our Programs", to: "/academics/postgraduate/programs" },
  { label: "Graduate Thesis", to: "/academics/postgraduate/thesis" },
  { label: "BU Journal", to: "/academics/postgraduate/journal" },
];

const quickLinks = [
  { label: "Apply Online", to: "/appllyonline" },
  { label: "Academic Calendar", to: "/callender" },
  { label: "BU Research", to: "/research/publications" },
  { label: "Contact BU", to: "/bucontacts" },
];

const seal =
  "https://bu-page-assets.s3.ap-northeast-1.amazonaws.com/static-assets/others/Benadir University Logo.png";

const PostgradFooter = () => {
  return (
    <footer className="pg-portal-footer mt-auto bg-[#0a3d6b] text-sky-50">
      <div className="pg-footer-grid">
        <div className="pg-footer-brand">
          <img src={seal} alt="Benadir University" />
          <p className="pg-footer-kicker">Benadir University</p>
          <h2>Postgraduate Studies &amp; Research</h2>
          <p className="pg-footer-desc">
            Advancing graduate education for Somalia since 2002 — from clinical
            specialties to education, engineering, and public leadership.
          </p>
        </div>

        <div className="pg-footer-col">
          <p className="pg-footer-heading">Shortcuts</p>
          <ul>
            {portalLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="pg-footer-col">
          <p className="pg-footer-heading">Quick access</p>
          <ul>
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="pg-footer-col">
          <p className="pg-footer-heading">Get in touch</p>
          <ul>
            <li>
              <a href="tel:+252615559323">Call us: +252-61-5559323</a>
            </li>
            <li>
              <a href="mailto:info@bu.edu.so">Email: info@bu.edu.so</a>
            </li>
            <li>Wadada Jaamacadda Benadir, Hodan, Mogadishu</li>
          </ul>
          <div className="pg-footer-socials">
            <a
              href="https://www.facebook.com/BenadirUniv"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF size={16} />
            </a>
            <a
              href="https://twitter.com/BenadirUniv"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <IoLogoTwitter size={16} />
            </a>
            <a
              href="https://www.instagram.com/benadiruniv/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram size={16} />
            </a>
            <a
              href="https://www.youtube.com/@benadiruniv"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-[#0863AA]">
        <p className="mx-auto max-w-6xl px-4 py-3 text-center text-xs font-semibold text-white sm:px-6">
          © {new Date().getFullYear()} Benadir University · School of
          Postgraduate Studies. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default PostgradFooter;
